import React from 'react';


function LessonRow({
    lesson,
    onDelete,
    onEdit,
    }) {
    
    return (
  
            <tr>
                <td className='lesson-title'>
                    {lesson.title}
                </td>

            <td className='lesson-pdf-col' > 
                <a 
                    className="lesson-link"
                    href={lesson.pdfUrl} 
                    target='_blank' 
                    rel="noopener noreferrer"
                    >
                    PDF
                </a> 
            </td>

            <td className="lesson-image-col">
                <a
                    className="lesson-link"
                    href={lesson.imageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    Image
                </a>
            </td>

            <td className="lesson-delete-col">
                <button
                style={{marginTop: '2px', marginBottom: '2px'}}
                className="lesson-delete-btn"
                onClick={() =>
                    onDelete(lesson.maneuverId)
                }
    
                title="Delete Maneuver"
                >
                    🗑️
                </button>


            </td>
            <td className="lesson-edit-col">
                <button
                    style={{marginTop: '2px', marginBottom: '2px'}}
                    className="edit-maneuver-btn"
                    type="button"
                    onClick={() => onEdit(lesson)}
                    title="Edit Maneuver"
                    >
                     ✏️
                    
                    
                </button>
            </td>

           

            </tr> 
            
    );
} 

export default LessonRow;
